<template>
  <div v-if="userDetail">
    <header>マイページ</header>
    <div id="wrap2" style="width: 100vw; min-height: 100vh">
      <div class="mypage01 clearfix">
        <div class="mypage02">
          <a @click="openShowUploadImage" id="parent_avatar">
            <img
              v-if="
                parseInt(userDetail.sex) === FEMALE &&
                !isUpload &&
                !getAvatar(userDetail.avatar_url)
              "
              src="~@/assets/images/profile_woman_p.png"
            />
            <img
              v-if="
                parseInt(userDetail.sex) === MALE &&
                !isUpload &&
                !getAvatar(userDetail.avatar_url)
              "
              src="~@/assets/images/profile_man_p.png"
            />
            <img
              v-if="!isUpload && getAvatar(userDetail.avatar_url)"
              :src="getImageUrl(userDetail.avatar_url)"
              style="width: 92px; height: 92px; object-fit: cover"
            />
            <div v-if="isUpload || !checkApproveAvatar(userDetail.avatar_url)">
              審査中
            </div>
          </a>
        </div>
        <div class="mypage03">
          <p>
            <i class="fas fa-user-circle"></i>
            {{ userDetail.display_name }} {{ userDetail.age }}歳
          </p>
          <p>
            <i class="fas fa-map-marker-alt"></i>
            {{ getFieldProfile("living_area", userDetail.living_area) }} 新宿区
          </p>
          <p><i class="fab fa-product-hunt orange"></i> 所持ポイント：{{userDetail.point}}pt</p>
          <div class="mypage04">
            <a
              @click="
                $router.push({ name: 'editProfile' });
                setFooter(false);
              "
              >プロフィール編集</a
            >
          </div>
          <div class="mypage05">
            <a @click="$router.push({ name: 'buyPoint' })">ポイント追加</a>
          </div>
        </div>
      </div>

      <div class="mypage06">
        <p class="b">プロフィール完成度</p>
        <table>
          <tr>
            <th>
              <div class="meter">
                <div
                  class="meter2"
                  :style="'width: ' + Math.round(getPercent() * 100) + '%'"
                ></div>
              </div>
            </th>
            <td>{{ Math.round(getPercent() * 100) }}%</td>
          </tr>
        </table>
      </div>

      <div class="mypage07">
        <table>
          <tr>
            <td>会える待ち</td>
            <td>
              <div class="switch3">
                <label class="switch3__label"
                  ><input
                    type="checkbox"
                    class="switch3__input"
                    v-model="formData.waiting_for_meet"
                    @change="updateProfile('waiting_for_meet')" /><span
                    class="switch3__content"
                  ></span
                  ><span class="switch3__circle"></span
                ></label>
              </div>
            </td>
            <td>音声通話待ち</td>
            <td>
              <div class="switch3">
                <label class="switch3__label"
                  ><input
                    type="checkbox"
                    class="switch3__input"
                    v-model="formData.waiting_voice_call"
                    @change="updateProfile('waiting_voice_call')" /><span
                    class="switch3__content"
                  ></span
                  ><span class="switch3__circle"></span
                ></label>
              </div>
            </td>
          </tr>
          <tr>
            <td>ビデオ通話待ち</td>
            <td>
              <div class="switch3">
                <label class="switch3__label"
                  ><input
                    type="checkbox"
                    class="switch3__input"
                    v-model="formData.waiting_video_call"
                    @change="updateProfile('waiting_video_call')" /><span
                    class="switch3__content"
                  ></span
                  ><span class="switch3__circle"></span
                ></label>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <ul class="mypage08 clearfix">
        <li>
          <p
            v-if="parseInt(userDetail.is_new_notice) > 0"
            class="mypage-alert"
          ></p>
          <a
            @click="
              $router.push({ name: 'notification' });
              setFooter(false);
            "
            ><img src="~@/assets/images/mypage01.png"
          /></a>
        </li>
        <li>
          <p
            v-if="parseInt(userDetail.is_new_campaign) > 0"
            class="mypage-alert"
          ></p>
          <a
            @click="
              $router.push({ name: 'campaign' });
              setFooter(false);
            "
            ><img src="~@/assets/images/mypage02.png"
          /></a>
        </li>
        <li>
          <a
            @click="
              $router.push({ name: 'favorite' });
              setFooter(false);
            "
            ><img src="~@/assets/images/mypage03.png"
          /></a>
        </li>
        <li>
          <p
            v-if="parseInt(userDetail.is_new_footprint) > 0"
            class="mypage-alert"
          ></p>
          <a
            @click="
              $router.push({ name: 'footprint' });
              setFooter(false);
            "
            ><img src="~@/assets/images/mypage04.png"
          /></a>
        </li>
        <li v-if="parseInt(userDetail.sex) === MALE">
          <p
            v-if="parseInt(userDetail.is_verify_assets) < 0"
            class="mypage-alert2"
          >
            !
          </p>
          <a
            @click="showModel('show_assets_model')"
            v-if="parseInt(userDetail.is_verify_assets) < 0"
          >
            <img src="~@/assets/images/mypage05.png" />
          </a>
          <a
            v-else-if="parseInt(userDetail.is_verify_assets) === 0"
          >
            <img src="~@/assets/images/mypage05.png" />
            <div>審査中</div>
          </a>
          <a v-else>
            <img src="~@/assets/images/ic_asset_verified.png" />
          </a>
        </li>
        <li v-if="parseInt(userDetail.sex) === MALE">
          <p
            v-if="parseInt(userDetail.is_verify_income) < 0"
            class="mypage-alert2"
          >
            !
          </p>
          <a
          @click="showModel('show_income_model')"
            v-if="parseInt(userDetail.is_verify_income) < 0"
          >
            <img src="~@/assets/images/mypage06.png" />
          </a>
          <a
            v-else-if="parseInt(userDetail.is_verify_income) === 0"
          >
            <img src="~@/assets/images/mypage06.png" />
            <div>審査中</div>
          </a>
          <a v-else>
            <img src="~@/assets/images/ic_income_verified.png" />
          </a>
        </li>
        <li v-if="parseInt(userDetail.sex) === MALE">
          <p
            v-if="parseInt(this.userDetail.is_subscription) !== IS_SUBSCRIPTION"
            class="mypage-alert2"
          >
            !
          </p>
          <a
            @click="redirectSubscription"
            v-if="parseInt(this.userDetail.is_subscription) !== IS_SUBSCRIPTION"
          >
            <img src="~@/assets/images/mypage07.png" />
          </a>
          <a v-else>
            <img src="~@/assets/images/ic_premium.png" />
          </a>
        </li>
        <li v-if="parseInt(userDetail.sex) === FEMALE">
          <a @click="$router.push({ name: 'settings' })"
            ><img src="~@/assets/images/mypage09.png"
          /></a>
        </li>
        <li>
          <p
            v-if="parseInt(this.userDetail.is_verify_age) < 0"
            class="mypage-alert2"
          >
            !
          </p>
          <a
            @click="redirectVeryAge"
            v-if="parseInt(this.userDetail.is_verify_age) < 0 "
          >
            <img src="~@/assets/images/mypage08.png" />
          </a>
          <a
            v-else-if="parseInt(this.userDetail.is_verify_age) === 0 "
          >
            <img src="~@/assets/images/mypage08.png" />
            <div>審査中</div>
          </a>
          <a v-else>
            <img src="~@/assets/images/ic_age_verified.png" />
          </a>
        </li>
        <li v-if="parseInt(userDetail.sex) === MALE">
          <a @click="$router.push({ name: 'settings' })"
            ><img src="~@/assets/images/mypage09.png"
          /></a>
        </li>
        <li>
          <a
            @click="
              $router.push({ name: 'memo' });
              setFooter(false);
            "
            ><img src="~@/assets/images/mypage10.png"
          /></a>
        </li>
      </ul>
    </div>
  </div>
  <basicDialog :active="isShowChooseTypeImage">
    <div class="flex-row">
      <button class="btn-start" @click="openCamera">カメラから</button>
      <button class="btn-end" @click="openFile">ギャラリーから</button>
      <button
        class="btn-close"
        @click="
          isShowChooseTypeImage = false;
          isChooseImage = false;
        "
      >
        キャンセル
      </button>
      <input type="file" name="fileImage" hidden />
    </div>
  </basicDialog>
  <!-- <basicDialog :active="isShowTypeMatching">
    <div class="flex-row">
        <button class="btn-start" @click="chooseType(VIEW_STATUS_AVATAR_ALL)">
            全会員に表示
        </button>
        <button class="btn-start-1" @click="chooseType(VIEW_STATUS_AVATAR_LIKE)">
            いいねしたお相手のみに表示
        </button>
        <button class="btn-end" @click="chooseType(VIEW_STATUS_AVATAR_MATCHING)">
            マッチングしたお相手のみに表示
        </button>
        <button class="btn-close" @click="isShowTypeMatching = false">
            キャンセル
        </button>
    </div>
</basicDialog> -->
  <nav v-if="isShowPhotoModal" style="overflow: auto">
    <div id="modal">
      <div class="modal">
        <p><img src="~@/assets/images/pop-ph.jpg" /></p>
        <div class="btn1"><a @click="closeModalPhoto">OK</a></div>
      </div>
    </div>
  </nav>
  <input type="file" accept="image/*" id="camera" capture="camera" hidden />
  <input type="file" accept="image/*" id="image" hidden />
  <!-- -------------------------------------------------------------- -->
  <!-- assets -->
  <nav id="show_assets_model" style="display: none; overflow: auto">
    <div id="modal">
      <div class="modal">
        <div class="swiper-container" id="swiper_container_assets">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="~@/assets/images/pop-assets01.png" />
            </div>
            <div class="swiper-slide">
              <img src="~@/assets/images/pop-assets02.jpg" />
            </div>
          </div>
          <div class="swiper-pagination" id="swiper_pagination_assets"></div>
        </div>

        <div class="btn1">
          <a href="#" @click="doProof('file_assets')">資産証明をおこなう</a>
        </div>
        <p class="">
          <a href="#" @click="closeModel('show_assets_model')">あとで</a>
        </p>
      </div>
    </div>
    <input
      type="file"
      hidden
      id="file_assets"
      accept="image/png, image/jpeg, image/jpg, image/gift"
    />
  </nav>

  <!-- income -->
  <nav id="show_income_model" style="display: none; overflow: auto">
    <div id="modal">
      <div class="modal">
        <div class="swiper-container" id="swiper_container_income">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="~@/assets/images/pop-income01.jpg" />
            </div>
            <div class="swiper-slide">
              <img src="~@/assets/images/pop-income02.jpg" />
            </div>
          </div>
          <div class="swiper-pagination" id="swiper_pagination_income"></div>
        </div>
        <div class="btn1">
          <a href="#" @click="doProof('file_income')">所得証明をおこなう</a>
        </div>
        <p class=""><a @click="closeModel('show_income_model')">あとで</a></p>
      </div>
    </div>
    <input
      type="file"
      hidden
      id="file_income"
      accept="image/png, image/jpeg, image/jpg, image/gift"
    />
  </nav>

  <div class="loading-screen" v-if="isLoading">
      <div class="loader"></div>
  </div>

  <div @click="closeAlert()">
    <successDialog :active="isVerySuccess" @close="closeAlert">
      <template v-slot:title>
        <p v-if="updateObject == 'file_income'">
          所得証明
        </p>
        <p v-else-if="updateObject == 'file_assets'">
          資産証明
        </p> 
      </template>
      <template v-slot:message>
        <p v-if="updateObject == 'file_income'">
          所得証明の申込みを受け付けました。審査は通常24時間以内に完了します。
        </p>
        <p v-else-if="updateObject == 'file_assets'">
          資産証明の申込みを受け付けました。審査は通常24時間以内に完了します。
        </p>
        <p v-else-if="successDialogMsg != ''">
          {{ successDialogMsg }}
        </p>
      </template>
      <!-- <p>
        
      </p> -->
    </successDialog>
  </div>

  <!-- <basicDialog :active="isAlert">
    <div class="message">
      プロフィールを更新しました。
    </div>
  </basicDialog> -->

  <!-- Footer height is 52px -->
  <alertDialogBottom style="margin-bottom: 52px" :active="isAlert">
      プロフィールを更新しました。
  </alertDialogBottom>

  <alertDialogBottom style="margin-bottom: 52px" :active="isAlertBottom">
      変更しました。
  </alertDialogBottom>
</template>

<script>
import Swiper from "@/assets/js/swiper.min.js";
import { mapGetters, mapActions } from "vuex";
import CONSTANTS from "@/constants";
import basicDialog from "./components/basicDialog";
import mixin from "@/mixin";
import successDialog from "@/views/components/successDialog";
import alertDialogBottom from "@/views/components/alertDialogBottom.vue";
export default {
  mixins: [mixin],
  components: {
    basicDialog,
    successDialog,
    alertDialogBottom
  },
  data: () => ({
    is_assets_swiped: false,
    is_income_swiped: false,
    formData: {
      waiting_for_meet: null,
      waiting_voice_call: null,
      waiting_video_call: null,
    },
    totalUnreadAll: 0,
    isShowPhotoModal: false,
    isChooseImage: false,
    isShowChooseTypeImage: false,
    isUpdateStatus: false,
    picture: null,
    VIEW_STATUS_AVATAR_ALL: CONSTANTS.VIEW_STATUS_AVATAR_ALL,
    VIEW_STATUS_AVATAR_LIKE: CONSTANTS.VIEW_STATUS_AVATAR_LIKE,
    VIEW_STATUS_AVATAR_MATCHING: CONSTANTS.VIEW_STATUS_AVATAR_MATCHING,
    isShowTypeMatching: false,
    file: null,
    viewStatus: 1,
    fileList: [],
    isSubmit: false,
    index: 1,
    isMain: true,
    isUploadMoodStatus: false,
    isUpload: false,
    PC_APPROVE: CONSTANTS.PC_APPROVE,
    IS_VERY_AGE: CONSTANTS.IS_VERY_AGE,
    NO_VERY_AGE: CONSTANTS.NO_VERY_AGE,
    IS_SUBSCRIPTION: CONSTANTS.IS_SUBSCRIPTION,
    NO_SUBSCRIPTION: CONSTANTS.NO_SUBSCRIPTION,
    MALE: CONSTANTS.MALE,
    FEMALE: CONSTANTS.FEMALE,
    isLoading: false,
    isVerySuccess: false,
    updateObject: '',
    successDialogMsg: '',
    isAlert: false,
    isAlertBottom: false
  }),

  async mounted() {
    this.setFooter(true);
    await this.userProfile({
      token: this.defaultToken,
    });
    if (this.userDetail) {
      this.formData.waiting_for_meet =
        parseInt(this.userDetail.waiting_for_meet) === CONSTANTS.IS_WAITING
          ? true
          : false;
      this.formData.waiting_voice_call =
        parseInt(this.userDetail.waiting_voice_call) === CONSTANTS.IS_WAITING
          ? true
          : false;
      this.formData.waiting_video_call =
        parseInt(this.userDetail.waiting_video_call) === CONSTANTS.IS_WAITING
          ? true
          : false;
    }
  },
  computed: {
    ...mapGetters([
      "profileTemplate",
      "defaultToken",
      "userDetail",
      "metadata",
    ]),
  },

  methods: {
    ...mapActions({
      userProfile: "user/userProfile",
      setFooter: "layout/setFooter",
    }),
    showModel(element_id) {
      document.getElementsByTagName('body')[0].style.overflow = "hidden";
      document.getElementById(element_id).style.display = "block";

      if (!this.is_assets_swiped && element_id == "show_assets_model") {
        this.is_assets_swiped = true;
        new Swiper("#swiper_container_assets", {
          slidesPerView: 1,
          loop: true,
          speed: 1000,
          autoplay: 3000,
          pagination: "#swiper_pagination_assets",
        });
      }

      if (!this.is_income_swiped && element_id == "show_income_model") {
        this.is_income_swiped = true;
        new Swiper("#swiper_container_income", {
          slidesPerView: 1,
          loop: true,
          speed: 1000,
          autoplay: 3000,
          pagination: "#swiper_pagination_income",
        });
      }
    },

    closeModel(element_id) {
      document.getElementsByTagName('body')[0].style.overflow = "auto";
      document.getElementById(element_id).style.display = "none";
    },

    doProof(element_id) {
      let fileInput = document.getElementById(element_id);
      fileInput.click();
      fileInput.addEventListener("change", async (e) => {
        this.isLoading = true;
        this.closeModel("show_income_model");
        this.closeModel("show_assets_model");

        let formData = new FormData();
        formData.append("token", this.defaultToken);
        if (element_id === "file_income") {
          formData.append("type", CONSTANTS.TYPE_VERIFY_INCOME);
        }
        if (element_id === "file_assets") {
          formData.append("type", CONSTANTS.TYPE_VERIFY_ASSET);
        }

        this.updateObject = element_id;

        await this.downscaleImage(fileInput.files[0]).then(file => {
          formData.append("file", file);
        });

        await this.$store
          .dispatch("profile/veryUpload", formData)
          .then((data) => {
            this.isLoading = false;
            this.isVerySuccess = true;
            this.userProfile({
              token: this.defaultToken,
            });
          })
          .catch((err) => {
            this.isLoading = false;
            console.log(err);
          });
      });
    },

    goToPage(toPage, fromPage, hideFooter) {
      document.getElementById(toPage).style.display = "block";
      document.getElementById(fromPage).style.display = "none";
      document.querySelector("footer").style.display = hideFooter;
    },

    ...mapActions({
      getDefaultToken: "user/getDefaultToken",
      getProfileTemplate: "profile/getProfileTemplate",
      setFooter: "layout/setFooter",
    }),
    getImage(images) {
      if (images) {
        let imgs = JSON.parse(images);
        if (imgs[0]) {
          imgs = imgs.filter((item) => {
            return (
              item.is_approve !== 2 &&
              !item.path.includes(CONSTANTS.URL_DEFAULT) &&
              item.is_approve !== -1
            );
          });
        }
        this.index = imgs.length;
        return imgs;
      }
    },
    getAvatar(image) {
      if (image.includes(CONSTANTS.URL_DEFAULT)) return null;
      return image;
    },
    checkApproveAvatar(image) {
      if (image.includes(CONSTANTS.URL_TEMP_AVATAR)) return false;
      return true;
    },
    async updateProfile(field) {
      let form = new FormData();
      form.append("token", this.defaultToken);
      this.formData[field] = this.formData[field]
        ? CONSTANTS.IS_WAITING
        : CONSTANTS.NO_WAITING;
      form.append(field, this.formData[field]);
      await this.$store
        .dispatch("user/userUpdate", form)
        .then((data) => {
          this.userProfile({
            token: this.defaultToken,
          });

          this.isAlertBottom = false
          setTimeout(() => {
              //Clear all Timeout
              let id = window.setTimeout(function() {}, 0);
              while (id--) {
                  window.clearTimeout(id); // will do nothing if no timeout with id is present
              }

              // Show bottom alert
              this.isAlertBottom = true
              setTimeout(() => {
                  this.isAlertBottom = false
              }, 1000)
          }, 50)
        })
        .catch((err) => {
          console.log(err);
        });
      this.formData[field] =
        parseInt(this.formData[field]) === CONSTANTS.IS_WAITING ? true : false;
    },
    // async getNoticeList() {
    //     let params = {
    //         page: 1,
    //         limit: 30,
    //         token: this.defaultToken,
    //     };

    //     await this.$store
    //         .dispatch("profile/getNotices", params)
    //         .then((data) => {
    //             this.totalUnreadAll = this.userDetail.is_new_notice;
    //         })
    //         .catch((err) => {});
    // },
    openShowUploadImage() {
      if (this.isUpload || !this.checkApproveAvatar(this.userDetail.avatar_url)) {
        this.isVerySuccess = true;
        this.successDialogMsg = '現在、審査中です。';
        return;
      }
      this.isShowPhotoModal = true;
      this.isChooseImage = true;
    },
    openCamera() {
      this.isShowPhotoModal = false;
      this.isChooseImage = false;
      this.isShowChooseTypeImage = false;
      let camera = document.getElementById("camera");
      camera.click();
      camera.addEventListener("change", (e) => {
        this.file = camera.files[0];
        this.fileList.push(camera.files[0]);
        this.chooseType();
        // this.isShowTypeMatching = true;
      });
    },
    openFile() {
      this.isShowPhotoModal = false;
      this.isChooseImage = false;
      this.isShowChooseTypeImage = false;
      let camera = document.getElementById("image");
      camera.click();
      camera.addEventListener("change", (e) => {
        this.file = camera.files[0];
        this.fileList.push(camera.files[0]);
        this.chooseType();
        // this.isShowTypeMatching = true;
      });
    },
    async submit() {
      if (this.fileList[0]) {
        this.index++;
        let formData = new FormData();
        formData.append("token", this.defaultToken);
        formData.append("is_main", 1);
        // formData.append("view_status", this.viewStatus);
        await this.downscaleImage(this.fileList[0]).then(file => {
          formData.append("images[0]", file);
        });
        await this.$store
          .dispatch("profile/uploadFileImages", formData)
          .then((data) => {
            // console.log(data);
            this.userProfile({
              token: this.defaultToken,
            });
          })
          .catch((err) => {
            console.log(err);
            this.isLoading = false;
          });
        this.fileList = [];
        this.file = null;
      }
    },
    closeModalPhoto() {
      this.isShowPhotoModal = false;
      if (this.isChooseImage) {
        this.isShowChooseTypeImage = true;
      }
    },
    chooseType() {
      this.isLoading = true;
      // this.viewStatus = viewStatus;
      let img = document.createElement("img");
      img.src = URL.createObjectURL(this.file);
      img.onload = function () {
        URL.revokeObjectURL(img.src);
      };
      img.style.width = "92px";
      img.style.height = "92px";
      img.style.objectFit = "cover";
      let parent = document.getElementById("parent_avatar");
      parent.appendChild(img);
      // this.isShowTypeMatching = false;
      this.isUpload = true;
      this.submit();
      this.$store
        .dispatch("user/userProfile", {
          token: this.defaultToken,
        })
        .then((data) => {
          this.isLoading = false;
          this.isAlert = true
          setTimeout(() => {
            this.isAlert = false
          }, 1000)
        });
    },
    redirectVeryAge() {
      if (parseInt(this.userDetail.is_verify_age) === this.IS_VERY_AGE) {
        return;
      }
      this.$router.push({
        name: "veryAge",
      });
      this.setFooter(false);
    },
    redirectSubscription() {
      if (parseInt(this.userDetail.is_subscription) === this.IS_SUBSCRIPTION) {
        return;
      }
      this.$router.push({
        name: "subscription",
      });
      this.setFooter(false);
    },
    getFieldProfile(field, id) {
      if (!this.metadata || !this.metadata.user_profile_list) return null;
      let filedData = this.metadata.user_profile_list[field].filter((item) => {
        return parseInt(item.value) === parseInt(id);
      });
      if (filedData[0]) {
        return filedData[0].name;
      }
      return CONSTANTS.NOT_VALUE;
    },

    getPercent() {
      var count = 0;
      if (this.userDetail == null) return 0.0;
      if (this.userDetail.mood_status) count++;
      if (this.userDetail.user_status) count++;
      if (this.userDetail.living_area) count++;
      if (this.userDetail.height) count++;
      if (this.userDetail.style) count++;
      if (this.userDetail.birth_place) count++;
      if (this.userDetail.roommate) count++;
      if (this.userDetail.child) count++;
      if (this.userDetail.education) count++;
      if (this.userDetail.job) count++;
      if (parseInt(this.userDetail.sex) === CONSTANTS.MALE && this.userDetail.income) count++;
      // if (this.userDetail.assets) count++;
      if (this.userDetail.holidays) count++;
      if (this.userDetail.drinking) count++;
      if (this.userDetail.smoking) count++;

      if (this.userDetail.meeting_condition) count++;
      if (this.userDetail.purpose) count++;

      if (this.userDetail.hobby) count++;
      if (this.userDetail.favorite_place) count++;
      if (this.userDetail.first_place) count++;

      return (
        count / (parseInt(this.userDetail.sex) === CONSTANTS.MALE ? 19 : 18)
      );
    },  
    closeAlert() {
      this.isVerySuccess = false
      this.updateObject = ''
    }
  },
};
</script>

<style lang="css" scoped>
.flex-row {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-row button {
  outline: none;
  border: none;
  color: #4a87fb;
  width: 100%;
  background: #fff;
  padding: 10px;
}

.flex-row button.btn-start {
  border-bottom: 1px solid rgb(160, 160, 160);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.flex-row button.btn-end {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.flex-row button.btn-close {
  margin-top: 15px;
  border-radius: 5px;
}

.btn-disable {
  height: 60px;
  width: 60px;
  background: linear-gradient(
    to right,
    rgb(161, 161, 161) 0%,
    rgb(133, 133, 133) 100%
  );
  text-align: center;
  font-weight: bold;
  border-radius: 100%;
  position: absolute;
  bottom: 10px;
  right: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 8px gray;
}

#parent_avatar {
  position: absolute;
  width: 92px;
  height: 92px;
}

#parent_avatar div {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2c2c2c87;
  height: 92px;
  width: 92px;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.mypage-alert2 {
  position: absolute;
  text-align: center;
  border-radius: 100%;
  background: #dd5e56;
  top: 10px;
  right: 10px;
  color: #fff;
  line-height: 18px;
  justify-content: center;
  font-size: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  line-height: 0;
  z-index: 999;
}
.mypage08 a {
  position: relative;
  display: block;
}
.mypage08 a div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00000057;
  height: 100%;
  color: #fff;
}
.mypage-alert {
  z-index: 999;
}
.loading-screen {
    background: #00000026;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.loader {
    display: inline-block;
    margin: 5px 0;
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 28px;
    border-radius: 50%;
    border: 2px solid #fff;
    border-right-color: transparent;
    -webkit-animation: spin 1s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
}

.message {
    color: #00000026;
    background: #fff;
    border-radius: 5px;
    padding: 5px;
}

@media (max-height: 360px) {
  #modal {
    padding-bottom: 100px;
    padding-top: 480px;
  }
}

@media (min-height: 361px) and (max-height: 670px) {
  #modal {
    padding-bottom: 100px;
    padding-top: 300px;
  }
}
</style>
